module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-de-1.171b543d.png";